<template>
  <mdb-container v-if="currentGroup">
    <div>
      <banner-small :group="currentGroup" title="Files"/>
    </div>

    <div class="text-left">
      <mdb-card class="mb-4">
        <mdb-card-header>
          <mdb-breadcrumb class="breadcrumb-with-arrows">
            <mdb-breadcrumb-item v-for="(bc,i) in breadcrumbs" :key="i">
              <span v-if="breadcrumbs.length == i+1">{{ bc.name }}</span>
              <a v-if="i+1 < breadcrumbs.length" href="" @click.prevent="folderNavUp(bc)">{{ bc.name }}</a>
            </mdb-breadcrumb-item>
          </mdb-breadcrumb>
        </mdb-card-header>
        <mdb-card-body>
          <div v-if="mayEdit">
            <mdb-btn color="success"
                     icon="folder-plus"
                     size="sm"
                     @click="createModal = true">New Folder
            </mdb-btn>

            <mdb-btn v-if="files.length==0 && folders.length == 0 && currentFolder.id !=0"
                     color="danger" icon="trash"
                     size="sm" @click="deleteFolder">Delete Folder
            </mdb-btn>
            <mdb-btn v-if="currentFolder.id !=0"
                     icon="folder-tree"
                     size="sm" @click="moveFolder()">Move Folder
            </mdb-btn>
            <mdb-btn v-if="currentFolder.id != 0" size="sm" @click="renameModal = true">
              <mdb-icon icon="pencil-alt"/>
              Rename Folder
            </mdb-btn>
            <mdb-btn v-if="currentFolder.id != 0" size="sm" @click="updatePermission">
              <mdb-icon icon="key"/>
              Permissions
            </mdb-btn>
            <mdb-btn v-if="currentFolder.id != 0" size="sm" @click="$router.push('/group/' + $route.params.id + '/folder-page/' + currentFolder.id)">
              <mdb-icon icon="browser"/>
              View as File Page
            </mdb-btn>
          </div>

          <mdb-row>
            <mdb-col v-for="folder in folders" v-bind:key="folder.id" md="4">
              <a role="button" @click="loadFolders(folder)">
                <mdb-icon v-if="folder.id != 0 && !folder.isNew" far icon="folder" size="2x"/>
                <mdb-icon v-if="folder.isNew" color="success" far icon="folder" size="2x"/>
                <mdb-icon v-if="folder.id == 0 && folder.name == 'Trash'" color="danger" far icon="trash" size="2x"/>
                <span v-if="folder.isNew" class="text-success">{{ folder.name }}</span>
                <span v-if="!folder.isNew">{{ folder.name }}</span>

              </a>
            </mdb-col>
          </mdb-row>
        </mdb-card-body>
      </mdb-card>
    </div>
    <div v-if="currentFolder.id != 0">
      <mdb-card>
        <mdb-card-header class="secondary-color">
          <h3>Files</h3>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-row v-if="mayEdit">
            <mdb-col md="12">
              <div class="text-left">
                <mdb-btn v-if="!showUpload && !(currentFolder.id==0 && currentFolder.name=='Trash')" size="sm"
                         @click.native="showUpload=true">
                  <mdb-icon icon="upload"/>
                  Upload New File(s)
                </mdb-btn>
                <mdb-btn v-if="showUpload" size="sm" @click.native="showUpload=false">
                  <mdb-icon icon="times-circle"/>
                  Cancel Upload
                </mdb-btn>
                <mdb-btn v-if="files.length >1" icon="check" size="sm" @click="selectAll">Select All</mdb-btn>
                <mdb-btn v-if="files.length >1" icon="minus-circle" size="sm" @click="deSelectAll">Select None
                </mdb-btn>
                <mdb-btn v-if="files.length >0" :disabled="!anyFileSelected" icon="folder-tree" size="sm"
                         @click="moveAllSelected">Move AlL Selected
                </mdb-btn>
                <mdb-btn v-if="!(currentFolder.id == 0 && currentFolder.name == 'Trash') && files.length>0"
                         :disabled="!anyFileSelected"
                         color="danger" icon="trash" size="sm" @click="deleteSelected">Delete AlL Selected
                </mdb-btn>
              </div>
            </mdb-col>
          </mdb-row>
          <mdb-row class="mb-4 mt-2" v-if="mayEdit && showUpload">
            <mdb-col col="12">
              <mdb-btn v-if="readyToUpload && !uploading" color="success" icon="upload" @click="uploadFiles">Upload Now
              </mdb-btn>
              <mdb-file-upload :disabled="uploading" :files="filesToUpload" multiple @change="handleChange"/>
              <div class="small">Max Size is 8MB</div>
            </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-tbl striped responsive class="text-left">
              <mdb-tbl-head class="secondary-color">
                <tr>
                  <th v-if="mayEdit">&nbsp;</th>
                  <th>&nbsp;</th>
                  <th class="h5"><a class="text-white" title="Sort" href="" @click.prevent="sort('name')">Name</a></th>
                  <th class="h5"><a class="text-white" title="Sort" href="" @click.prevent="sort('date')">Created</a></th>
                  <th class="h5 text-primary">Created By</th>
                </tr>
              </mdb-tbl-head>
              <mdb-tbl-body>
                <tr v-for="file in files" v-bind:key="file.id" md="3">
                  <td v-if="mayEdit">
                    <mdb-input class="cust-check" :id="'checkbox-'+file.id" v-model="file.selected" type="checkbox"/>
                  </td>
                  <td>
                    <a href="" @click.prevent="downloadFile(file)" title="Download File">
                      <mdb-icon icon="download"/>
                    </a>
                    &nbsp; &nbsp;
                    <a href="" @click.prevent="getLink(file)" title="Get link to file.">
                      <mdb-icon icon="link"/>
                    </a>
                  </td>
                  <td v-if="!file.label">
                    <span class="text-info">{{ file.name }}</span>
                    <div v-if="mayEdit">
                      <a class="text-primary" href="" @click.prevent="editLabel(file)">Add Friendly Label <mdb-icon icon="tag"/></a>
                    </div>
                  </td>
                  <td v-if="file.label">
                    <div class="text-info">{{ file.label }}
                      <a v-if="mayEdit" href="" @click.prevent="editLabel(file)"><mdb-icon size="md" icon="pencil"/></a>
                    </div>
                    <div class="small">{{file.name}}</div>

                  </td>
                  <td>{{ file.created }}</td>
                  <td>{{ file.createdBy }}</td>
                </tr>
              </mdb-tbl-body>
            </mdb-tbl>
          </mdb-row>
        </mdb-card-body>
      </mdb-card>
    </div>

    <mdb-modal :show="createModal" class="text-center" size="lg" @close="createModal=false">
      <mdb-modal-header :close="true" center class="primary-color text-white">
        <h3 class="heading">New Folder</h3>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-input id="newFolderName" v-model="newFolderName" active label="Name"
                   @keydown.native="handleCreateKeyDown"/>
        <mdb-btn @click="createFolder">
          <mdb-icon icon="save"/>
          Save
        </mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal :show="renameModal" class="text-center" size="lg" @close="renameModal=false">
      <mdb-modal-header :close="true" center class="primary-color text-white">
        <h3 v-if="currentFolder" class="heading">Rename {{ currentFolder.name }} </h3>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-input id="renameFolderName" v-model="newFolderName" active label="New Name"
                   @keydown.native="handleRenameKeyDown"/>
        <mdb-btn @click="renameFolder">
          <mdb-icon icon="save"/>
          Save
        </mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal :show="permissionModal" class="text-left" size="lg" @close="permissionModal=false">
      <mdb-modal-header :close="true" center class="primary-color text-white">
        <h3>Folder Permission</h3>
      </mdb-modal-header>
      <mdb-modal-body>
        <div class="h5 text-info">Who can view files in this folder?</div>
        <mdb-input id="permission-admin" v-model="workingPermission"
                   label="Admins" name="permission-admin"
                   radioValue="Admin" type="radio"/>
        <mdb-input id="permission-group-org" v-model="workingPermission"
                   label="Admins & Group Organizers" name="permission-group-org"
                   radioValue="Group Organizer" type="radio"/>
        <mdb-input id="permission-event-org" v-model="workingPermission"
                   label="Admins, Group Organizers & Event Organizers" name="permission-event-org"
                   radioValue="Event Organizer" type="radio"/>
        <mdb-input id="permission-members" v-model="workingPermission"
                   label="All Members" name="permission-members"
                   radioValue="Member" type="radio"/>
        <mdb-input id="permission-public" v-model="workingPermission"
                   label="Public" name="permission-public"
                   radioValue="Public" type="radio"/>
        <mdb-btn @click="savePermission">
          <mdb-icon icon="save"/>
          Save
        </mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal :show="labelModal" class="text-center" size="lg" @close="labelModal=false">
      <mdb-modal-header :close="true" center class="primary-color text-white">
        <h3 class="heading">Friendly File Label</h3>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-input id="working-label" v-model="workingLabel" active label="Label"
                   @keydown.native="handleLabelKeyDown"/>
        <mdb-btn :disabled="!workingLabel" @click="saveLabel" icon="save">
          Save
        </mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

    <mdb-modal :show="showMoveFolder" scrollable size="lg" @close="showMoveFolder=false">
      <mdb-modal-header :close="true" class="primary-color text-white">
        <h5>Move to....</h5>
      </mdb-modal-header>
      <mdb-modal-body>
        <file-folder-navigator :group="currentGroup"
                               :exclude-folder="currentFolder"
                               select-label="Move to"
                               :allow-root="false" folders-only @selectedFolder="moveToFolder"/>

      </mdb-modal-body>
    </mdb-modal>

    <yes-no-modal v-if="showDeleteModal" @no="showDeleteModal=false" @yes="doDeleteSelected"/>

  </mdb-container>

</template>
<script>
import draggable from "vuedraggable"
import api from '../../services/groupsPlaceApi.js'
import bannerSmall from '../group/BannerSmall'
import error from '../common/Error'
import mdbFileUpload from 'mdbvue-file-upload'
import Vue from 'vue';
import FileFolderNavigator from "../common/FileFolderNavigator";
import YesNoModal from "../common/YesNoModal";
import {custChipInput} from "../common/CustChipInput";
import download from "js-file-download";

import {
  mdbBadge,
  mdbBreadcrumb,
  mdbBreadcrumbItem,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbListGroup,
  mdbListGroupItem,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbTooltip,
  mdbTreeview,
  mdbTreeviewItem,
  mdbView
} from 'mdbvue';

export default {
  name: "group-files",
  display: "Files",
  order: 1,
  watch: {
    createModal: function (n, o) {
      if (n) {
        Vue.nextTick().then(function () {
          let el = document.getElementById("newFolderName")
          if (el) el.focus()
        })
      }
    },
    renameModal: function (n, o) {
      if (n) {
        Vue.nextTick().then(function () {
          let el = document.getElementById("renameFolderName")
          if (el) el.focus()
        })
      }
    }
  },
  components: {
    mdbContainer,
    mdbBtn,
    mdbBreadcrumb,
    mdbBreadcrumbItem,
    mdbRow,
    mdbCol,
    mdbListGroup,
    mdbListGroupItem,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardImage,
    mdbMask,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbIcon,
    mdbTreeview,
    mdbTreeviewItem,
    mdbBadge,
    mdbView,
    mdbTooltip,
    mdbInput,
    mdbFileUpload,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    draggable,
    bannerSmall,
    error,
    FileFolderNavigator,
    YesNoModal,
    custChipInput
  },
  computed: {
    currentGroup() {
      return this.$store.state.currentGroup
    },
    settings() {
      return this.$store.state.settings
    },
    anyFileSelected() {
      for (let i of this.files) {
        if (i.selected) return true
      }
    },
    mayEdit() {
      if (!this.currentGroup) return false
      if (this.currentGroup.permissions.includes("Manage Files")) return true
      return false
    }
  },

  mounted() {
    api.groupBasics(this.$route.params.id, "member")
    this.loadFolders(null)

  },
  data() {
    return {
      folders: [],
      files: [],
      filesToUpload: [],
      error: null,
      currentFolder: {id: 0, name: "Top"},
      hasTrash: false,
      createModal: false,
      renameModal: false,
      permissionModal: false,
      showUpload: false,
      newFolderName: "",
      showMoveFolder: false,
      moveCandidates: [],
      moveAllSelectedFiles: false,
      uploading: false,
      readyToUpload: false,
      gotError: false,
      breadcrumbs: [],
      showDeleteModal: false,
      workingFile: null,
      workingLabel: "",
      labelModal: false,
      sortField: "name",
      sortDir: "asc",
      workingPermission: ""

    };
  },
  methods: {
    async getLink(file){
      if (!navigator.clipboard) {
        this.$notify.error({message: "Your browser does not support copying to clipboard.", timeOut: 2500})
        return
      }
      try {
        await navigator.clipboard.writeText(this.settings.frontEndUrl + "/file/" + file.id + "/" + file.accessCode)
        this.$notify.success({message: "Link copied to clipboard.", timeOut: 2500})
      } catch (e) {
        this.$notify.error({message: "Error copying to clipboard." + e, timeOut: 2500})
      }
    },
    savePermission() {
      this.permissionModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/groupFile/setPermission/" + this.currentFolder.id, {permission: this.workingPermission}).then(
        (details) => {
          this.currentFolder.viewerRole = this.workingPermission
          this.workingPermission = ""
        },
        (error) => {
          this.$notify.error({message: "Error setting label."})
          this.permissionModal = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    updatePermission() {
      this.workingPermission = this.currentFolder.viewerRole
      this.permissionModal = true
    },
    sort(field) {
      if (field == this.sortField) {
        if (this.sortDir == "asc") this.sortDir = "desc"
        else this.sortDir = "asc"
      }
      else {
        this.sortField = field
      }
      this.loadFolders(this.currentFolder)
    },
    editLabel(file) {
      this.workingFile = file
      this.workingLabel = file.label
      this.labelModal = true
      this.$nextTick().then(() => {
        let el = document.getElementById("working-label")
        if (el) el.focus()
      })

    },
    saveLabel() {
      this.labelModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/groupFile/labelFile/" + this.workingFile.id, {label: this.workingLabel}).then(
        (details) => {
          this.workingFile.label = this.workingLabel
          this.workingLabel = ""
          this.workingFile = null
        },
        (error) => {
          this.$notify.error({message: "Error setting label."})
          this.labelModal = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    selectAll() {
      for (let i of this.files) i.selected = true
    },
    deSelectAll() {
      for (let i of this.files) i.selected = false
    },
    folderNavUp(folder) {
      this.currentPresentation = null
      this.pages = []
      this.presentations = []
      this.loadFolders(folder)
    },

    loadFolders(folder) {
      this.folders = []
      this.files = []
      this.$store.dispatch("setExecuting", true)
      let url = "/groupFile/list/" + this.$route.params.id + "/"
      url += "?fileSort=" + this.sortField + "&fileSortDir=" + this.sortDir
      if (folder) url += "&folder=" + folder.id

      api.get(url).then(
        (details) => {
          this.folders = details.data.folders
          this.files = details.data.files
          this.breadcrumbs = details.data.breadcrumbs
          if (folder) this.currentFolder = folder
          else {
            this.currentFolder = this.breadcrumbs[this.breadcrumbs.length - 1]
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    handleRenameKeyDown(e) {
      if (e.keyCode === 13) {
        this.renameFolder()
      }
    },
    handleLabelKeyDown(e) {
      if (e.keyCode === 13) {
        this.saveLabel()
      }
    },
    handleCreateKeyDown(e) {
      if (e.keyCode === 13) {
        this.createFolder()
      }
    },
    handleChange(x) {
      if (this.filesToUpload.length > 0) this.readyToUpload = true
      else this.readyToUpload = false
    },
    async downloadFile(file) {
      this.$store.dispatch("setExecuting", true)
      let downloadInfo = await api.getGroupFileLink(file.id, file.accessCode)
      if (!downloadInfo) {
        this.$store.dispatch("setExecuting", false)
        this.$notify.error({message: "File unavailable", timeOut: 4000})
        return
      }
      const response = await fetch(downloadInfo.url)
      const blob = await response.blob()
      download(blob, downloadInfo.fileName)
      this.$store.dispatch("setExecuting", false)

    },
    async uploadFiles() {
      this.uploading = true
      this.showUpload = false
      this.readyToUpload = false
      await this.$store.dispatch("setExecuting", true)
      let url = "/groupFile/uploadRequest"

      this.gotError = false
      for (let file of this.filesToUpload) {
        if (file.size == 0) {
          this.$notify.warn({message: "File " + file.name + " skipped - empty!", timeOut: 4000})
        } else {
          if (!this.gotError) {
            let payload = { folder: this.currentFolder.id, filename: file.name, size: file.size,
                             contentType: file.type }

            let uploadRequest
            await api.post(url, payload).then(
              (results) => {
                uploadRequest = results.data
              },
              (error) => {
                this.gotError = true
                this.showUpload = true
                this.$notify.error({message: error.response.data, timeOut: 5000})
                this.$store.dispatch("setExecuting", false)
              }
            )

            const response = await fetch(uploadRequest.url, {
              method: 'PUT',
              body: file,
              headers: {
                'Content-Type': file.type
              },
            })

            if (!response.ok) {
              const errorText = await response.text()
              this.gotError = true
              this.showUpload = true
              this.$notify.error({message: errorText, timeOut: 5000})
              this.$store.dispatch("setExecuting", false)
              return
            }

            payload.uploadRequestId = uploadRequest.id

            api.post("/groupFile/uploadComplete", payload).then(
              (results) => {
                this.files.unshift(results.data.file)
              },
              (error) => {
                this.gotError = true
                this.showUpload = true
                this.$notify.error({message: error.response.data, timeOut: 5000})
                this.$store.dispatch("setExecuting", false)
              }).then(() => {
              this.uploading = false
            })

          }
        }
      }
      this.filesToUpload = []
      await this.$store.dispatch("setExecuting", false)
    },

    moveToFolder: function (folder) {
      this.showMoveFolder = false
      let url
      if (this.moveCandidates.length > 0) url = "/groupFile/moveFiles/"
      else url = "/groupFile/moveFolder/" + this.currentFolder.id
      this.$store.dispatch("setExecuting", true)
      api.post(url, {folder: folder, candidates: this.moveCandidates}).then(
        (details) => {
          if (this.moveCandidates.length > 0) {
            let message = "File moved to " + folder.name
            if (this.moveCandidates.length > 1) message = this.moveCandidates.length + " files moved to " + folder.name
            this.$notify.success({message: message, timeOut: 3000})
            this.moveCandidates = []
          }
          this.loadFolders(this.currentFolder)
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    moveAllSelected: function () {
      this.showMoveFolder = true
      this.moveCandidates = []
      for (let i of this.files) {
        if (i.selected) this.moveCandidates.push(i)
      }

    },
    moveFolder: function () {
      this.showMoveFolder = true
      this.moveCandidate = []
    },
    renameFolder: function () {
      if (!this.newFolderName || !this.newFolderName.trim()) {
        this.$notify.error({message: "Folder name cannot be empty."})
        return
      }
      this.$store.dispatch("setExecuting", true)
      api.post("/groupFile/renameFolder/" + this.currentFolder.id, {name: this.newFolderName}).then(
        (details) => {
          this.currentFolder.name = this.newFolderName
          this.breadcrumbs[this.breadcrumbs.length - 1].name = this.newFolderName
          this.newFolderName = ""
          this.renameModal = false
        },
        (error) => {
          this.$notify.error({message: "Error renaming folder"})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    createFolder: function () {
      if (!this.newFolderName || !this.newFolderName.trim()) {
        this.$notify.error({message: "Folder name cannot be empty."})
        return
      }
      this.$store.dispatch("setExecuting", true)
      let url = "/groupFile/create/" + this.currentGroup.vanityPath
      api.put(url, {
        name: this.newFolderName,
        folder: this.currentFolder
      }).then(
        (details) => {
          this.folders.unshift(details.data)
          this.newFolderName = ""
          this.createModal = false
        },
        (error) => {
          this.$notify.error({message: "Error creating folder"})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    deleteFolder: function () {
      this.$store.dispatch("setExecuting", true)
      api.delete("/groupFile/delete/" + this.currentFolder.id).then(
        (details) => {
          let loc = this.folders.indexOf(this.currentFolder)
          this.currentFolder = null
          if (this.breadcrumbs.length <= 2) this.loadFolders(null)
          else this.loadFolders(this.breadcrumbs[this.breadcrumbs.length - 2])
        },
        (error) => {
          this.$notify.error({message: "Error deleting folder"})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    navTop: function () {
      this.currentFolder = null
    },
    deleteSelected: function () {
      this.showDeleteModal = true
    },
    doDeleteSelected: function () {
      this.showDeleteModal = false
      let deleteCandidates = []
      for (let i of this.files) {
        if (i.selected) deleteCandidates.push(i.id)
      }
      this.$store.dispatch("setExecuting", true)
      let url = "/groupFile/deleteFiles"

      api.post(url, deleteCandidates).then(
        (details) => {
          this.loadFolders(this.currentFolder)
          this.$notify.success({message: "Moved to trash folder!.", timeOut: 5000})
        },
        (error) => {
          this.$notify.error({message: "Error deleting file(s)."})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};

</script>
<style scoped>
.no-padding {
  padding: 0 !important;
}

.top-actions {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #ffffff;
  opacity: 0.9;
}

</style>


